/**
 * 拓扑插件-按钮事件代码常量定义
 */
export default {
  // 保存数据
  saveData: 'SAVE_DATA',
  // 撤销操作
  undoOperate: 'UNDO_OPERATE',
  // 恢复操作
  redoOperate: 'REDO_OPERATE',
  // 选择图形
  selectShape: 'SELECT_SHAPE',
  // 图形连线
  joinLineShape: 'JOIN_LINE_SHAPE',
  // 复制图形
  copyShape: 'COPY_SHAPE',
  // 透明度
  transparency: 'TRANSPARENCY',
  // 左对齐
  alignLeft: 'ALIGN_LEFT',
  // 右对齐
  alignRight: 'ALIGN_RIGHT',
  // 顶部对齐
  alignTop: 'ALIGN_TOP',
  // 底部对齐
  alignBottom: 'ALIGN_BOTTOM',
  // 水平居中
  horizontalCenter: 'HORIZONTAL_CENTER',
  // 垂直居中
  verticalCenter: 'VERTICAL_CENTER',
  // 水平分布间距
  horizontalSpacing: 'HORIZONTAL_SPACING',
  // 垂直分布间距
  verticalSpacing: 'VERTICAL_SPACING',
  // 图层置顶
  layerTop: 'LAYER_TOP',
  // 图层置底
  layerBottom: 'LAYER_BOTTOM',
  // 图层上移一层
  layerUp: 'LAYER_UP',
  // 图层下移一层
  layerDown: 'LAYER_DOWN',
  // 组合图形
  groupShape: 'GROUP_SHAPE',
  // 取消图形组合
  ungroupShape: 'UNGROUP_SHAPE',
  // 锁定图形
  lockShape: 'LOCK_SHAPE',
  // 取消图形锁定
  unlockShape: 'UNLOCK_SHAPE',
  // 删除图形
  deleteShape: 'DELETE_SHAPE',
  // 全屏
  fullScreen: 'FULL_SCREEN',
  // 预览舞台
  previewStage: 'PREVIEW_STAGE',
  // 窗口左侧组件栏
  windowLeft: 'WINDOW_LEFT',
  // 窗口右侧属性栏
  windowRight: 'WINDOW_RIGHT',
  // 画布缩小
  canvasZoomOut: 'CANVAS_ZOOM_OUT',
  // 画布放大
  canvasZoomIn: 'CANVAS_ZOOM_IN',
  // 适应屏幕
  canvasFitView: 'CANVAS_FIT_VIEW',
  // 实际大小
  canvasActualSize: 'CANVAS_ACTUAL_SIZE',
  // 全选
  selectAllGraph: 'SELECT_ALL_GRAPH',
  // 清空画布
  clearCanvasGraph: 'CLEAR_CANVAS_GRAPH',
  // 上移动
  moveGraphUp: 'MOVE_GRAPH_UP',
  // 下移动
  moveGraphDown: 'MOVE_GRAPH_DOWN',
  // 左移动
  moveGraphLeft: 'MOVE_GRAPH_LEFT',
  // 右移动
  moveGraphRight: 'MOVE_GRAPH_RIGHT'
};
